import {NAV_VIEWTYPE} from "../../config/constants"

export const isPrimaryNavbarLink = (viewType?: string) => {
    return viewType === NAV_VIEWTYPE.PRIMARY_NAVBAR_LINK
}
